const pageNameKey = "sourcesListRowForGatewaysList";

export const sourcesListRowForGatewaysListEn = {
  [pageNameKey]: {
    sourceIconAltText: "Source",
    gatewayIconAltText: "Gateway",
    goToTreeStructure: "Go to Tree Structure",
    goToConditionMonitoring: "Go to Condition Monitoring",
    goToDashboard: "Go to Dashboard",
    noSoftwareVersion: "No software version",
    noMachineId: "No Machine ID",
    goToMachineSettings: "Go to Machine Settings",
    goToShotDataTable: "Go to Shot data table",
  },
};

export const sourcesListRowForGatewaysListPtBr = {
  [pageNameKey]: {
    sourceIconAltText: "Fonte",
    gatewayIconAltText: "Gateway",
    goToTreeStructure: "Ir para Estrutura de Árvore",
    goToConditionMonitoring: "Acesse o Monitoramento de condição",
    goToDashboard: "Ir para o painel",
    noSoftwareVersion: "Nenhuma versão do software",
    noMachineId: "Sem ID de máquina",
    goToMachineSettings: "Vá para as Configurações da máquina",
    goToShotDataTable: "Ir para tabela de dados de shot",
  },
};

export const sourcesListRowForGatewaysListDe = {
  [pageNameKey]: {
    sourceIconAltText: "Quelle",
    gatewayIconAltText: "Gateway",
    goToTreeStructure: "Gehe zu Tree Structure",
    goToConditionMonitoring: "Gehe zu Condition Monitoring",
    goToDashboard: "Gehe zum Dashboard",
    noSoftwareVersion: "Keine Softwareversion",
    noMachineId: "Keine Maschinen-ID",
    goToMachineSettings: "Gehen Sie zu Maschineneinstellungen",
    goToShotDataTable: "Zur Shot-Datentabelle gehen",
  },
};

export const sourcesListRowForGatewaysListZhHans = {
  [pageNameKey]: {
    sourceIconAltText: "源",
    gatewayIconAltText: "网关",
    goToTreeStructure: "转到树结构",
    goToConditionMonitoring: "转到条件监控",
    goToDashboard: "转到仪表板",
    noSoftwareVersion: "没有软件版本",
    noMachineId: "没有机器ID",
    goToMachineSettings: "转到机器设置",
    goToShotDataTable: "转到注射数据表",
  },
};

export const sourcesListRowForGatewaysListIt = {
  [pageNameKey]: {
    sourceIconAltText: "Sorgente",
    gatewayIconAltText: "Gateway",
    goToTreeStructure: "Vai alla struttura nodi",
    goToConditionMonitoring: "Vai al monitoraggio condizioni",
    goToDashboard: "Vai alla dashboard",
    noSoftwareVersion: "Nessuna versione del software",
    noMachineId: "Nessun ID macchina",
    goToMachineSettings: "Vai alle impostazioni macchina",
    goToShotDataTable: "Vai alla tabella dati shot",
  },
};

export const sourcesListRowForGatewaysListEs = {
  [pageNameKey]: {
    sourceIconAltText: "Fuente",
    gatewayIconAltText: "Gateway",
    goToTreeStructure: "Ir a estructura en árbol",
    goToConditionMonitoring: "Ir a monitorización de condición",
    goToDashboard: "Ir al panel",
    noSoftwareVersion: "Sin versión de software",
    noMachineId: "Sin ID de máquina",
    goToMachineSettings: "Ir a la configuración de la máquina",
    goToShotDataTable: "Ir a la tabla de datos de shot",
  },
};

export const sourcesListRowForGatewaysListNl = {
  [pageNameKey]: {
    gatewayIconAltText: "Gateway",
    goToConditionMonitoring: "Ga naar conditiebewaking",
    goToDashboard: "Ga naar Dashboard",
    goToMachineSettings: "Ga naar machine-instellingen",
    goToShotDataTable: "Ga naar shot-gegevens tabel",
    goToTreeStructure: "Ga naar boomstructuur",
    noMachineId: "Geen machine-ID",
    noSoftwareVersion: "Geen softwareversie",
    sourceIconAltText: "Bron",
  },
};

export const sourcesListRowForGatewaysListTr = {
  [pageNameKey]: {
    gatewayIconAltText: "Geçit",
    goToConditionMonitoring: "Durum İzlemeye Git",
    goToDashboard: "Kontrol Paneline Git",
    goToMachineSettings: "Makine Ayarlarına Git",
    goToTreeStructure: "Ağaç Yapısına Git",
    noMachineId: "Makine Kimliği Yok",
    noSoftwareVersion: "Yazılım sürümü yok",
    sourceIconAltText: "Kaynak",
    goToShotDataTable: "Şut verileri tablosuna git",
  },
};
